import { render, staticRenderFns } from "./file.vue?vue&type=template&id=2649fb60&scoped=true"
import script from "./file.vue?vue&type=script&lang=ts"
export * from "./file.vue?vue&type=script&lang=ts"
import style0 from "./file.vue?vue&type=style&index=0&id=2649fb60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2649fb60",
  null
  
)

export default component.exports